

export abstract class ModuleBase {


    abstract init(): void;

    abstract onClear(): void;

    abstract onLoad(): void;

    abstract onDestroy(): void;

    abstract onPreloadData(): void;

    abstract inits2c(): void;

}
